export default __webpack_public_path__ + "static/media/go.4330f20e.png";